import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage id="menu.recently-played" defaultMessage="Recently Played" />
);
